<template>
  <div class="container-fluid">
    <router-link class="btn btn-circle torre-red" :to="{ name: 'storesNew' }" title="Dodaj sklep">
      <i class="material-icons" >
      add
      </i>
    </router-link>
    <div v-if="msg.show" :class="'alert ' + msg.type" role="alert">
      {{ msg.text }}
    </div>
    <table class="table table-hover">
      <thead>
        <tr>
          <th class="table-50">Nazwa</th>
          <th class="table-50">Edytuj</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in stores" :key="item.id">
          <td>{{ item.name }}</td>
          <td><router-link :to="{ name: 'storesEdit', params: { id: item.id} }">edytuj</router-link></td>
        </tr>
      </tbody>
    </table>
    <common-pagination @paginationClicked="onPaginationClicked"/>
  </div>
</template>

<script>
import userService from '@/service/userService'
import axios from 'axios'
import appConfig from '@/service/config'
import flashService from '@/service/flashService'
import MainPresenter from "@/service/MainPresenter"

const mainPresenter = new MainPresenter();

export default {
  name: 'Stores',
  data: function () {
    return {
      pageable: appConfig.pageableMainParams,
      stores: [],
      msg:{
        show: false,
        text: "",
        type: ""
      }
    }
  },
  created: function () {
    this.pageable.page = 0;
    const msg = flashService.get("msg");
    if (msg) {
      this.msg = {
        show: true,
        text: msg.text,
        type: msg.type
      }
    }
    this.reloadContent();
  },
  methods: {
    reloadContent() {
      this.pageable.sort = "name,asc"
      const req = axios({
        method: 'get',
        url: mainPresenter.getUrlForCommonData("/stores?sort=name", {}, this.pageable),
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.stores = res.data._embedded.stores;
        this.$emit('dataChanged', {
          data: res.data
        });
      }).catch(_ => {
        console.log('blad categories')
      })
    },
    onPaginationClicked(payload) {
      var pageToSend = payload.pageToSend;
      this.pageable.page = pageToSend;
      this.reloadContent();
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/stores/Stores.vue